import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'featured-brand',
    name: 'web-content.featured-brand',
    meta: {
      title: 'Featured Brand',
      action: 'read',
      subject: CASL.ACCESS.FEATURED_BRAND
    },
    component: () => import('./FeaturedBrandPage.vue')
  }
]
